import layout from "./layout";
import chat from "../pages/chat/store";

const rootReducer = {
  layout,
  chat,
};
export default rootReducer;
